import './styles/base.scss'
import './styles/tokens/index.scss'
import { createRoot } from 'react-dom/client'
import { bridgeAuthResponse, initAuth, isAuthCallback } from './auth'
import { App, createApp } from './app/providers'
import { applyStoredScheme } from './shell/colorScheme'

// Boot (SPEC §3): MSAL initialise + redirect handling + session restore,
// then providers and the router. Nothing renders before MSAL has settled,
// as in the portal's pages/index.tsx. The MSAL popup or iframe on
// /auth-callback only hands its response back and never boots the app.
applyStoredScheme()

const handedOver = isAuthCallback() && (await bridgeAuthResponse())

if (!handedOver) {
  const root = document.getElementById('root')
  if (!root) throw new Error('#root is missing from index.html')

  try {
    await initAuth()
  } catch (error) {
    // A broken MSAL setup must not blank the page: the login screen reports it.
    console.error('Error initializing MSAL:', error)
  }

  createRoot(root).render(<App app={createApp()} />)
}
